import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { NAVIGATE_TO } from '@routes'
import { observer } from 'mobx-react-lite'

import {
  AcButton,
  AcCheckbox,
  AcColumn,
  AcFormInput,
  AcFormProvider,
  AcTypography,
} from '@components'
import { LABELS } from '@constants'
import { useStore } from '@hooks'

export const AcceptTermsView = observer(() => {
  const navigate = useNavigate()
  const location = useLocation()
  const { user, toaster } = useStore()
  const [loading, setLoading] = useState(false)

  const defaultRoutePerRole = () => {
    if (user.isOfficeManager) {
      return NAVIGATE_TO.ADMIN_DASHBOARD
    }
    return NAVIGATE_TO.LUNCHER_OVERVIEW
  }

  const onSubmit = async () => {
    setLoading(true)
    try {
      await user.patchAcceptTc()
      const from = (location.state as any)?.from
      navigate(from?.pathname || defaultRoutePerRole(), { replace: true })
    } catch {
      toaster.error({ content: LABELS.ACCEPT_TERMS_ERROR })
    } finally {
      setLoading(false)
    }
  }

  return (
    <AcFormProvider
      initial={{ accept_tc: false }}
      onSubmit={onSubmit}
      flexGrow={1}>
      <AcColumn gap={0}>
        <AcTypography
          color="green.main"
          bold>
          {LABELS.ACCEPT_TERMS_TITLE}
        </AcTypography>

        <AcTypography
          component="p"
          size="xs">
          Om onze diensten correct te kunnen leveren, verwerken wij bepaalde
          persoonsgegevens. In ons{' '}
          <a
            href="https://www.debuurtboer.nl/privacystatement/"
            target="_blank"
            rel="noopener noreferrer">
            privacybeleid
          </a>{' '}
          lees je welke gegevens wij gebruiken, voor welke doeleinden en hoe wij
          deze beveiligen. Door verder te gaan, verklaar je kennis te hebben
          genomen van en akkoord te gaan met ons privacybeleid.
        </AcTypography>

        <AcFormInput
          register="accept_tc"
          rules={{ required: LABELS.FIELD_REQUIRED }}
          Component={
            <AcCheckbox
              variant="default"
              id="accept_tc"
              label={LABELS.ACCEPT_TERMS_CHECKBOX}
              required
            />
          }
        />

        <AcButton
          type="submit"
          variant="primary"
          loading={loading}
          fullWidth
          sx={{ marginTop: 6 }}>
          {LABELS.CONFIRM}
        </AcButton>
      </AcColumn>
    </AcFormProvider>
  )
})
